import { useState, useCallback, useRef } from "react";
import { ContractorHandlerKey } from "../context/ContractorContext";

export const useContractorDialog = () => {
  const [dialogHandlerKey, setDialogHandlerKey] =
    useState<ContractorHandlerKey | null>(null);
  const dialogConfirmCallback = useRef<(() => void) | null>(null);

  const openDialog = useCallback(
    (handlerKey: ContractorHandlerKey, onConfirm: () => void) => {
      setDialogHandlerKey(handlerKey);
      dialogConfirmCallback.current = onConfirm;
    },
    [],
  );

  const closeDialog = useCallback(() => {
    setDialogHandlerKey(null);
    dialogConfirmCallback.current = null;
  }, []);

  const confirmDialog = useCallback(() => {
    if (dialogConfirmCallback.current) {
      dialogConfirmCallback.current();
    }
  }, []);

  return {
    dialogHandlerKey,
    openDialog,
    closeDialog,
    confirmDialog,
  };
};
